import { baseSplitApi } from "../baseApi";


const loginAuthPath = "/auth/login";
const logoutPath = "/auth/logout"
const verifyOtpPath = "/auth/verify_otp"
const verifyUserPath = "/auth/verify_user"

const loginAuthApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    loginClient: build.mutation({
      query: (user) => {
        return {
          url: `${loginAuthPath}`,
          body: user,
          method: 'POST'
        }
      },
    }),
    logoutClient: build.mutation({
      query: () => {
        return {
          url: `${logoutPath}`,
          method: 'POST'
        }
      }
    }),
    verifyOtp: build.mutation({
      query: (body) => {
        return {
          url: `${verifyOtpPath}`,
          body,
          method: 'POST'
        }
      }
    }),
    verifyUser: build.mutation({
      query: ({ userId, clientIndex }) => {
        return {
          url: `${verifyUserPath}/${userId}`,
          method: 'POST',
          body:{clientIndex}
        }
      }
    }),
    checkIfUserIsAuthenticated: build.query({
      query: () => {
        return {
          url: `auth/check_if_user_authenticated`
        }
      }
    })
  }),
  overrideExisting: false
})

export const { useLoginClientMutation, useLogoutClientMutation, useVerifyOtpMutation, useVerifyUserMutation, useCheckIfUserIsAuthenticatedQuery } = loginAuthApi;